import { render, staticRenderFns } from "./RulesMenuView.vue?vue&type=template&id=12e2ebbd&"
import script from "./RulesMenuView.vue?vue&type=script&lang=js&"
export * from "./RulesMenuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports